<template>
  <div>
    <br />
    <h5 class="card-title">
      {{ $t("message.comply_advantage.case_management_tab") }}
    </h5>
    <br />
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-gr2oup form-group',
            ]"
          >
            <input
              id="filter-name"
              type="text"
              class="form-control"
              v-model="filter.name"
              :placeholder="$t('message.comply_advantage.filter_name')"
              autocomplete="off"
              style="cursor: auto"
            />
            <label for="filter-name" class="form-label-group-label">{{
              $t("message.comply_advantage.filter_name")
            }}</label>
          </span>
        </div>
        <div class="col-md-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-gr2oup form-group',
            ]"
          >
            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="filter.date_from = ' '"
              @blur="
                filter.date_from == ' '
                  ? (filter.date_from = '')
                  : (filter.date_from = filter.date_from)
              "
              inputClass="form-control"
              v-model="filter.date_from"
              :placeholder="$t('message.comply_advantage.filter_date_from')"
              :inputAttr="{ id: 'filter_date_from' }"
            >
              <template v-slot:icon-calendar>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H5C3.34315 4 2 5.34315 2 7V11V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V11V7C22 5.34315 20.6569 4 19 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4H8V3ZM16 6H8V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V6H5C4.44772 6 4 6.44772 4 7V9.99999L20 10V7C20 6.44772 19.5523 6 19 6H18V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7V6ZM4 19V12L20 12V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z"
                    fill="#797980"
                  />
                </svg>
              </template>
            </datepicker>
            <label
              for="filter_date_from"
              class="form-label-group-label shorter"
              :class="
                filter.date_from != '' && filter.date_from != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.comply_advantage.filter_date_from") }}</label
            >
          </span>
        </div>
        <div class="col-md-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-gro2up form-group',
            ]"
          >
            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="filter.date_to = ' '"
              @blur="
                filter.date_to == ' '
                  ? (filter.date_to = '')
                  : (filter.date_to = filter.date_to)
              "
              inputClass="form-control"
              v-model="filter.date_to"
              :placeholder="$t('message.comply_advantage.filter_date_to')"
              :inputAttr="{ id: 'filter_date_to' }"
            >
              <template v-slot:icon-calendar>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3V4H5C3.34315 4 2 5.34315 2 7V11V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V11V7C22 5.34315 20.6569 4 19 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4H8V3ZM16 6H8V7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7V6H5C4.44772 6 4 6.44772 4 7V9.99999L20 10V7C20 6.44772 19.5523 6 19 6H18V7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7V6ZM4 19V12L20 12V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z"
                    fill="#797980"
                  />
                </svg>
              </template>
            </datepicker>
            <label
              for="filter_date_to"
              class="form-label-group-label shorter"
              :class="
                filter.date_to != '' && filter.date_to != null ? 'topped' : ''
              "
              >{{ $t("message.comply_advantage.filter_date_to") }}</label
            >
          </span>
        </div>

        <div class="col-md-3 d-none">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              id="filter-reference"
              type="text"
              class="form-control"
              v-model="filter.reference"
              :placeholder="$t('message.comply_advantage.filter_reference')"
              autocomplete="off"
              style="cursor: auto"
            />
            <label for="filter-reference" class="form-label-group-label">{{
              $t("message.comply_advantage.filter_reference")
            }}</label>
          </span>
        </div>
      </div>
      <div class="row d-none">
        <!--<div class="col-md-2">
                            <span :class="['bmd-form-group mb-2 d-block form-label-group',  filter_assigned_to_focused?'focused':'']">
                                <checkbox-dropdown :options="assigned_to_types" v-model="filter.assigned_to" :placeholder="$t('message.comply_advantage.filter_assigned_to')"></checkbox-dropdown>
                            </span>
                    </div>-->
        <!--<div class="col-md-2">
                            <span :class="['bmd-form-group mb-2 d-block form-label-group',  filter_searched_by_focused?'focused':'']">
                                <checkbox-dropdown :options="searched_by_types" v-model="filter.searched_by" :placeholder="$t('message.comply_advantage.filter_searched_by')"></checkbox-dropdown>
                            </span>
                    </div>-->
        <!--<div class="col-md-2">
                            <span :class="['bmd-form-group mb-2 d-block form-label-group',  filter_changed_focused?'focused':'']">
                                <checkbox-dropdown :options="changed_types" v-model="filter.changed" :placeholder="$t('message.comply_advantage.filter_changed')"></checkbox-dropdown>
                            </span>
                    </div> -->
        <div class="col-md-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              filter_monitored_focused ? 'focused' : '',
            ]"
          >
            <!-- <v-select :options="monitored_types" label="display_text" :class="['form-control', typeof filter.monitored !== 'undefined' && filter.monitored.value!==''?'vs--selected':'']" v-model="filter.monitored" :placeholder="$t('message.comply_advantage.filter_monitored')" @focus="comply_filter_monitored_focused" @blur="comply_filter_monitored_blurred"></v-select>	 -->

            <!-- <v-select-popup :idata="monitored_types" v-model="filter.monitored" :placeholder="$t('message.comply_advantage.filter_monitored')"/> -->

            <!-- <label class="form-label-group-label shorter">{{$t('message.comply_advantage.filter_monitored')}}</label> -->
            <!--<checkbox-dropdown :options="monitored_types" v-model="filter.monitored" :placeholder="$t('message.comply_advantage.filter_monitored')"></checkbox-dropdown>-->
          </span>
        </div>
        <div class="col-md-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              filter_match_focused ? 'focused' : '',
            ]"
          >
            <!--<v-select :options="match_types" label="display_text" :class="['form-control', typeof filter.match !== 'undefined' && filter.match.value!==''?'vs--selected':'']" v-model="filter.match" :placeholder="$t('message.comply_advantage.filter_match')" @focus="comply_filter_match_focused" @blur="comply_filter_match_blurred"></v-select>	
                                <label class="form-label-group-label shorter">{{$t('message.comply_advantage.filter_match')}}</label>-->
            <checkbox-dropdown
              :options="match_types"
              v-model="filter.match"
              :placeholder="$t('message.comply_advantage.filter_match')"
            ></checkbox-dropdown>
          </span>
        </div>
        <div class="col-md-3">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group',
              filter_risk_focused ? 'focused' : '',
            ]"
          >
            <!--<v-select :options="risk_types" label="display_text" :class="['form-control', typeof filter.risk !== 'undefined' && filter.risk.value!==''?'vs--selected':'']" v-model="filter.risk" :placeholder="$t('message.comply_advantage.filter_risk')" @focus="comply_filter_risk_focused" @blur="comply_filter_risk_blurred"></v-select>	
                                <label class="form-label-group-label shorter">{{$t('message.comply_advantage.filter_risk')}}</label> -->
            <checkbox-dropdown
              :options="risk_types"
              v-model="filter.risk"
              :placeholder="$t('message.comply_advantage.filter_risk')"
            ></checkbox-dropdown>
          </span>
        </div>

        <!-- <div class="col-md-2">
                            <span :class="['bmd-form-group mb-2 d-block form-label-group',  filter_matched_types_focused?'focused':'']">
                                <checkbox-dropdown :options="matched_types_types" v-model="filter.matched" :placeholder="$t('message.comply_advantage.filter_matched')"></checkbox-dropdown>
                            </span>
                    </div> -->
      </div>
      <!-- <button :class="['btn', 'btn-success', 'btn-round', 'btn-sm', loading?'pl-5':'']" @click="searchManagement(filter)" id="init_search"><div class="loading loading-button" v-if="loading" style="margin-top: -2px;    left: 16px;"></div>  {{$t('message.comply_advantage.apply_filters')}}</button> -->
      <!-- <button class="btn btn-primary btn-round btn-sm ml-4"  @click="clearFilter" id="clear-filter">{{$t('message.comply_advantage.remove_filters')}}</button> -->
      <div class="col-md-12">
        <div
          class="togglebutton other mt-md-3 form-label-group d-flex justify-content-start"
        >
          <label
            class="control-label d-flex"
            style="
              display: flex !important;
              flex-wrap: nowrap;
              flex-direction: column-reverse;
            "
          >
            <input type="checkbox" v-model="filter.monitored" />
            <span class="toggle"></span>
            <span style="margin-left: 60px">{{
              $t("message.comply_advantage.only_monitored")
            }}</span>
          </label>
        </div>
      </div>
      <div></div>
    </div>

    <!-- <br><br>
            <div class="justify-content-end" v-if="selected_cases.length > 0" >
                <button class="btn btn-sm btn-link text-danger float-right" @click="deleteCases()"><i class="fa fa-trash fa-2x"></i></button>
            </div> -->
    <!-- <div class="turn-monitoring-on d-flex align-items-end mb-3 justify-content-end" style="background-color: #17c671;width: 280px;padding: 20px;border-radius: 40px;right: 230px;position: absolute;margin-top: -80px;color: #fff;">
                {{ $t('message.find_partner.switch_monitoring_on') }}
                <img style="height: 20px;margin-bottom: -8px; margin-left: 5px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA+CAMAAABur6nZAAACDVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlWn0GAAAArnRSTlMAAQIDBAYHCAkKCw0ODxESExQVFhcYGRobHyIjJCUsLS4vMDE1Nzg5PD0+QEFCQ0RGR0lKUFJUVldYWVpbXF1gYWRlZmdobG1ub3FydXd7fH1+f4CBgoSFhoeIiouMjY6PkJOUlZaXmJqbnJ2en6Cio6WmqKmrrK+xs7W2t7i6vL2+v8DBwsPGycrLzM3O0NHS1NXX2tvc3d7f4eLk5+jp6+zt7/Dx8vT29/j5+vuT9OOfAAAB+0lEQVR42mIwBDRWD2quZFEAhc/1bdvGuMdo27Zt27Zt21qvOPZMJXt9iP4kpX2qPC05JbeyvWdoYmygv7u5ID3u+49s1X/j/3rabAux+Rfs5vfuLw4Ot3cPzs8AgLu2T/4p8+pSY/y/8nKyNFAvlHph8N7ZJyRz4Bxg4AOlN8Nvmp6B0rdKfw7p97D/uRJkXwPEKkmfbkGhSL7qhGIlqhqiZLIFnGVyg0UZdIIvpZs5L4OO4CqTcyTJYB7tMhjPkgxGsimDWWzIYBfLMnhGjsh9DR4iOMOxyHlCtgiugJnERUODxLnAvZEE7kCkxJXCpMR9C0+mAmcF+ClB69Ahcb2wKnG5gIXA+QI+AucGpAjc2xNoVYJm0Zyo0q2yl+qPGuHWRAMOweTr35/HAppL/QBgrH7tOyBUy726hvk/r2nKtddroOrXZ2bXMKz7PAT/cYa3lHYTgNcvT/rh0U7bvb2Bh1+u+UrgQ91DybhSKh+IVjoKAEqUSgJS9Q0HX6hEoFbpLAHOVQRQr3+MpjMQXPpFAJJb5BRkr94H6nUvr8D8nY3Smzucv/n12XtXv+yqtr6RkY6GIPXfwmBYmXwcXTZ6yl999l9YAQf9V/ze/dH8zOjgwprrf9ybC37vcrog3NvyldLIB+Bhryve21jp7Aeg01oJip8dU7r6CQmh9xL+u4B6AAAAAElFTkSuQmCC" alt="">
            </div> -->
    <b-table
      id="cases-table"
      responsive
      :items="filtered_cases"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:cell(names)="data">
        <p class="btn-link mb-0 monitor-widget" @click="openSearch(data)">
          {{ data.value }}
          <span class="badge badge-danger pt-0">{{
            data.item.total_hits
          }}</span>
        </p>
      </template>

      <template v-slot:cell(checkbox)="data">
        <input
          type="checkbox"
          @change="caseChecked($event)"
          :value="data"
          v-model="selected_cases"
        />
      </template>
      <template v-slot:cell(monitor)="data" class="text-center">
        <div
          class="togglebutton other mt-md-3 form-label-group d-flex justify-content-center"
          v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 180 }"
          :content="$t('message.comply_advantage.tippy')"
        >
          <label class="control-label">
            <input
              type="checkbox"
              @click="changeMonitoredState(data)"
              v-model="data.value"
            />
            <span class="toggle"></span>
          </label>
        </div>
        <label style="padding-left: 60px; margin-top: -20px"></label>
      </template>
      <template v-slot:cell(has_changes)="data" class="text-center">
        <div v-if="data.item.has_changes == true" class="badge badge-warning">
          {{ $t("message.comply_advantage.table_changes") }}
        </div>
      </template>
      <!-- <template v-slot:cell(changed)="data">
					 <div v-if="data.value" class="badge badge-success">
                        {{data.value}}

                     </div>
					    <p v-if="data.value" class="btn-link" @click="openDifferences(data, data.value)">{{$t('message.comply_advantage.check_differences')}}</p> 

				</template> -->
    </b-table>
    <div class="d-flex">
      <b-pagination
        v-model="currentPage"
        :total-rows="cases.length"
        :per-page="perPage"
        :hide-goto-end-buttons="true"
        aria-controls="cases-table"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {
        date_from: "",
        date_to: "",
        name: "",
        reference: "",
        match: [],
        risk: [],
        //ssigned_to: [],
        //searched_by: [],
        changed: [],
        monitored: false,
        matched_types: [],
      },
      selected_cases: [],
      loading: false,
      currentPage: 0,
      perPage: 10,
      cases: [],
      contrsearch_country_focus: false,
      filter_match_focused: false,
      filter_risk_focused: false,
      filter_searched_by_focused: false,
      filter_changed_focused: false,
      filter_monitored_focused: false,
      filter_matched_types_focused: false,

      filter_assigned_to_focused: false,
      countries: [],
      fields: [
        {
          key: "monitor",
          label: this.$t("message.comply_advantage.on_off_monitor"), //this.$t('message.comply_advantage.filter_monitored'),
          sortable: false,
          class: "bg-success-light",
        },
        {
          key: "created",
          label: this.$t("message.comply_advantage.table_created"),
          sortable: false,
        },
        {
          key: "names",
          label: this.$t("message.comply_advantage.table_names"),
          sortable: false,
        },
        {
          key: "ref",
          label: this.$t("message.comply_advantage.table_ref"),
          sortable: false,
        },
        {
          key: "match_status",
          label: this.$t("message.comply_advantage.table_match_status"),
          sortable: false,
        },

        {
          key: "risk_level",
          label: this.$t("message.comply_advantage.table_risk_level"),
          sortable: false,
        },
        {
          key: "has_changes",
          label: this.$t("message.comply_advantage.table_changes"),
          sortable: false,
        },
        {
          key: "changed",
          label: this.$t("message.comply_advantage.table_changed"),
          sortable: false,
        },
      ],
      changed_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_changed_all"),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_changed_changed",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_changed_unchanged",
          ),
          value: 2,
        },
      ],
      monitored_types: [
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_all",
          ),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_actively",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_suspended",
          ),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_unmonitored",
          ),
          value: 3,
        },
      ],
      matched_types_types: [
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_all",
          ),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_sanctions",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_warnings",
          ),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_fitness_probity",
          ),
          value: 3,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_peps_all",
          ),
          value: 4,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_1",
          ),
          value: 5,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_2",
          ),
          value: 6,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_3",
          ),
          value: 7,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_4",
          ),
          value: 8,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_adverse_media",
          ),
          value: 9,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_financial_crime",
          ),
          value: 10,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_violent_crime",
          ),
          value: 11,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_sexual_crime",
          ),
          value: 12,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_terrorism",
          ),
          value: 13,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_fraud",
          ),
          value: 14,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_narcotics",
          ),
          value: 15,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_other",
          ),
          value: 16,
        },
      ],
      searched_by_types: [{ display_text: "Test type", value: 0 }],
      risk_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_risk_all"),
          value: 0,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_unknown"),
          value: 1,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_low"),
          value: 2,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_medium"),
          value: 3,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_high"),
          value: 4,
        },
      ],
      assigned_to_types: [{ display_text: "Test type", value: 0 }],
      match_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_match_all"),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_unknown",
          ),
          value: 1,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_match_no"),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_potential",
          ),
          value: 3,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_false_positive",
          ),
          value: 4,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive",
          ),
          value: 5,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive_approve",
          ),
          value: 6,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive_reject",
          ),
          value: 7,
        },
      ],
    };
  },
  methods: {
    searchManagement(filter) {
      this.cases = [];
      var url = window.base + "/document/GetAMLSearches";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/ca_searches?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/ca_searches?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      axios.post(url, this.filter).then((response) => {
        response.data.forEach((item) => {
          var tmp = {};
          tmp.created = item.created_at;
          tmp.names = item.search_term;
          tmp.ref = item.ref;
          tmp.match_status = item.match_status;
          tmp.risk_level = item.risk_level;
          tmp.total_hits = item.total_hits;
          //tmp.assigned_to = "Sergey Nikolayev";
          //tmp.searcher = "Sergey";
          if (typeof item.monitors[0] !== "undefined") {
            tmp.changed = item.monitors[0].updated_at;
            tmp.has_changes = true;
          }

          tmp.monitor = item.monitor;
          tmp.id = item.id;
          this.cases.push(tmp);
        });
      });
    },
    clearFilter() {
      this.filter = {
        date_from: "",
        date_to: "",
        name: "",
        reference: "",
        match: [],
        risk: [],
        //assigned_to: [],
        //searched_by: [],
        changed: [],
        monitored: { value: "", display_text: "" },
        matched_types: [],
      };
      this.searchManagement(null);
    },
    changeMonitoredState(data) {
      console.log("chng monitored data");
      console.log(data);
      var url = window.base + "/document/UpdateAMLMonitored?id=";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/search_monitor_update?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&id=";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/search_monitor_update?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&id=";
      axios
        .patch(url + data.item.id + "&isMonitored=" + Boolean(!data.value))
        .then((response) => {
          console.log("monitor changed");
          console.log(response);
        });
    },
    comply_filter_monitored__focused() {
      this.filter_monitored_focused = true;
    },
    comply_filter_monitored__blurred() {
      this.filter_monitored_focused = false;
    },
    deleteCases() {
      var selected = this.selected_cases.map((item) => {
        return item.item.id;
      });
      var url = window.base + "/document/DeleteAMLSearches";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/delete_searches?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/delete_searches?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      axios.post(url, selected).then((response) => {
        console.log("Delete response");
        console.log(response.data);
        this.searchManagement(this.filter);
        if (response.data.includes("404") || response.data.includes("400")) {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.comply_advantage.case_delete_unsuccessful"),
            timeout: 5000,
          }).show();
        } else {
          new Noty({
            theme: "light",
            type: "success",
            text: this.$t("message.comply_advantage.case_deleted_successfully"),
            timeout: 5000,
          }).show();
        }
        this.selected_cases = [];
      });
    },
    caseChecked(e) {
      console.log("checking the checkbox");
      console.log(e);
      console.log("selected cases");
      console.log(this.selected_cases);
    },
    openSearch(data) {
      this.$root.$emit("open_ca_search_tab", data);
    },
    // openDifferences(data, refDate) {
    //     var url = window.base + '/document/GetAMLDifferences?id=';
    //     console.log('differences data');
    //     console.log(refDate)
    //     console.log(data)

    //     if(window.location.hostname=='attistrade.ru') url ='https://attistrade.kz/api/search_get_differences?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&id='
    //     if(window.location.hostname=='attistrade.cn') url ='https://attistrade.kz/api/search_get_differences?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809&id='
    //     axios.get(url + data.item.id /*+ '&date=' + refDate*/).then(response=>{
    //         console.log('open diff response');
    //         console.log(response.data);
    //     })
    // },
  },
  mounted() {
    // let tmp = {
    //     created: '2022',
    //     names: 'Jonas Dobrovolskis',
    //     ref: '123',
    //     match_status: '123',
    //     risk_level: '2',
    //     assigned_to: 'Sergey',
    //     searcher: 'Sergey',
    //     changed: 'asd',
    //     monitor: true

    // }
    // this.cases.push(tmp);
    this.searchManagement(null);
  },
  computed: {
    filtered_cases() {
      if (this.filter.monitored == true) {
        return this.cases.filter((item) => item.monitor == 1);
      }
      return this.cases;
    },
  },
};
</script>
<style scoped>
.form-group .form-control {
  /* border: 0; */
  /* height: 50px; */
  /* position: absolute; */
  /* box-shadow: none !important; */
  outline: none !important;
}
.form-group textarea.form-control {
  height: 104px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 24px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.togglebutton label {
}
.form-label-group input:not(:placeholder-shown),
.form-label-group textarea:not(:placeholder-shown) {
}
.togglebutton label span.choise_1,
.togglebutton label span.choise_2,
.togglebutton label span.female,
.togglebutton label span.male,
.togglebutton label span.toggle {
}
.custom-toggle .custom-control-label::before,
.togglebutton label .toggle::before {
}
.custom-toggle .custom-control-label::after,
.togglebutton label .toggle::after {
}
</style>
<style>
td.bg-success-light,
table th.bg-success-light {
  background: rgba(207, 235, 248, 0.5) !important;
}
.table thead th {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #797980;
}
.table thead td {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* neutral/10 */

  color: #333333;
}
.togglebutton label .toggle::before {
  background: #b1b1b1;
  border: 0;
  height: 22px;
  width: 44px;
}

.togglebutton label .toggle::before {
  background: #b1b1b1 !important;
  border: 0 !important;
  height: 22px !important;
  width: 44px !important;
}
.togglebutton label .toggle::after {
  width: 18px !important;
  height: 18px !important;
  background-color: #fff !important;
  top: 2px !important;
  left: 2px !important;
}
.togglebutton label input:checked ~ .toggle::before {
  background: linear-gradient(90deg, #b1b1b1  0%, #b1b1b1 100%) !important;
}
.togglebutton label input:checked ~ .toggle::after {
  left: 24px !important;
  transform: unset !important;
}
td .btn-link {
  color: #333333;
}
td .btn-link .badge-danger {
  padding: 4px;

  /* width: 22px; */
  height: 16px;

  /* attis/secondary */

  background: var(--color2);
  border-radius: 12px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  display: inline-flex;
  align-items: center;
  text-align: center;

  /* primary100 */

  color: #ffffff;
}
.pagination.b-pagination .page-item {
  box-shadow: none !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}
.pagination.b-pagination .page-item.active {
  background: #04416d;
}
.page-item.disabled .page-link {
  background-color: transparent !important;
  border-color: transparent !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */
  text-align: center;

  color: #ffffff;
}
.page-item .page-link {
  background: #04416d;
}
.page-item.active .page-link {
  background-color: transparent !important;
  border-color: transparent !important;
  width: 42px;
  height: 44px;

  /* attis/primary */

  background: #04416d;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* primary100 */

  color: #ffffff;
}
</style>
<style scoped>
.monitor-widget span {
  position: absolute;
  display: block;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.monitor-widget {
  position: relative;
}
</style>
<style>
.table thead th {
  border: 0;
}
</style>
